import { z } from "zod";
import { emailSchema } from "./common";

// Generic form schema factory function (similar to your donationDafFormSchema pattern)
export const createContactFormSchema = () => {
  return z.object({
    feedbackReason: z.string().min(1, "Please select a feedback reason"),
    subject: z.string().min(1, "Subject is required").max(200, "Subject must be less than 200 characters"),
    message: z.string().min(1, `Message is required`).max(2000, `Message must be less than 2000 characters`),
    email: emailSchema,
    attachments: z.array(z.any()).optional(),
  });
};
